import { useEffect, useState } from 'react';

/**
 * Debounce a value for server-side search (SKU / ASIN / order id / buyer).
 * Default 350ms — never filter huge lists only in the browser.
 */
export function useDebouncedValue(value, delayMs = 350) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
